import { gql } from '@apollo/client'

const ADD_NEW_POLICY_CLASS = gql`
  mutation ADD_NEW_POLICY_CLASS(
    $name: String!
    $maxLimit: Float
    $insuranceLimit: Float
    $insuranceUnlimited: Boolean
    $insurancePercentage: Float
    $approvalRequired: Boolean
    $disabled: Boolean
    $insurancePolicy: ID!
  ) {
    addNewPolicyClass(
      name: $name
      maxLimit: $maxLimit
      insuranceLimit: $insuranceLimit
      insuranceUnlimited: $insuranceUnlimited
      insurancePercentage: $insurancePercentage
      approvalRequired: $approvalRequired
      disabled: $disabled
      insurancePolicy: $insurancePolicy
    ) {
      id
      name
      maxLimit
      insuranceLimit
      insurancePercentage
      insuranceUnlimited
      approvalRequired
      disabled
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      insurancePolicy {
        id
        policyNumber
        holderName
        insuranceCompany {
          id
          name
        }
      }
    }
  }
`

export default ADD_NEW_POLICY_CLASS
